export var PaymentCategory;
(function (PaymentCategory) {
    PaymentCategory["OFFICE_SETUP"] = "officeSetup";
    PaymentCategory["ORDER"] = "order";
    PaymentCategory["VISIT"] = "visit";
})(PaymentCategory || (PaymentCategory = {}));
const cardBrandFriendlyNames = {
    amex: 'American Express',
    diners: 'Diners Club',
    discover: 'Discover',
    jcb: 'JCB',
    mastercard: 'Mastercard',
    unionpay: 'UnionPay',
    visa: 'Visa',
    unknown: 'Card',
};
export const getCardBrandFriendlyName = (stripeBrand) => { var _a; return (_a = cardBrandFriendlyNames[stripeBrand]) !== null && _a !== void 0 ? _a : 'Card'; };
//# sourceMappingURL=payments.js.map